// extracted by mini-css-extract-plugin
module.exports = {"postWrapper":"PostV1_postWrapper__3PWH9","titleAndMoreIcon":"PostV1_titleAndMoreIcon__1f9Um","userNameAndReviewProgress":"PostV1_userNameAndReviewProgress__ylKNd"};